import { type NodeUser, createNodeUser } from 'models';
import { useQuery } from 'query';
import { getUserIdFromLegacyId } from '../services';
import { getUserNodeQuery } from './keys';

export const useNodeUserQuery = (
  { railsId }: { railsId: string },
  options: { enabled?: boolean; throwOnError?: boolean } = {},
) =>
  useQuery<NodeUser>({
    async queryFn() {
      const { data: responseData } = await getUserIdFromLegacyId(railsId);
      const [userDataObject] = responseData.data;

      if (!userDataObject) {
        throw new Error(`User not found ${railsId}`);
      }

      return createNodeUser(userDataObject);
    },
    queryKey: getUserNodeQuery({ railsId }),
    throwOnError: true,
    ...options,
  });
